import React from 'react'
import { CommonCreateButtonProps } from '../../../types'
import { useNavigate } from 'react-router-dom'
import { Button, CircularProgress, IconButton, Tooltip } from '@mui/material';

const CommonCreateButton: React.FC<CommonCreateButtonProps> = ({
    onClick,
    navigateTo,
    label = 'Create',
    icon,
    color = 'primary',
    variant = 'contained',
    size = 'small',
    disabled = false,
    loading = false,
    show = true,
    fullWidth = false,
    sx = {},
    tooltip,
    startIcon,
    endIcon
}) => {
    const navigate = useNavigate();
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        if (navigateTo) {
            navigate(navigateTo)
        }
    }

    if (!show) {
        return null;
    }

    if (!label && icon) {
        return (
            <Tooltip title={tooltip}>
                <span>
                    <IconButton
                        color={color}
                        onClick={handleClick}
                        disabled={disabled || loading}
                        size={size}
                        sx={sx}
                    >
                        {loading ? <CircularProgress size={24} /> : icon}
                    </IconButton>
                </span>
            </Tooltip>
        )
    }

    const buttonContent = (
        <Button
            variant={variant}
            color={color}
            onClick={handleClick}
            disabled={disabled || loading}
            size={size}
            fullWidth={fullWidth}
            startIcon={loading ? <CircularProgress size={20} /> : (startIcon || icon)}
            endIcon={endIcon}
            sx={sx}
        >
            {label}
        </Button>
    )

    if (tooltip) {
        return (
            <Tooltip title={tooltip}>
                <span>
                    {buttonContent}
                </span>
            </Tooltip>
        );
    }

    return buttonContent;
}

export default CommonCreateButton